<template>
<div>
  <form class="form-horizontal" @submit.prevent="submit">
    <fieldset>
      <legend>Dane ogólne</legend>
      <form-group label="Data obowiązywania" :error="errors['date']">
        <date-picker v-model="priceList.date"></date-picker>
      </form-group>
    </fieldset>

    <fieldset>
      <legend>Dla sprzedających</legend>
      <form-group label="Pozycje cennika">
        <table class="table table-bordered">
          <thead>
          <tr>
            <td>Rodzaj pojazdu</td>
            <td>Cena</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in priceList.forSellers">
            <td>
              <text-input v-model="item.type"></text-input>
            </td>
            <td>
              <text-input v-model="item.price"></text-input>
            </td>
            <td>
              <question-button
                question="Czy na pewno usunąć pozycję?"
                @click="removePosition(priceList.forSellers, item)"
                class="btn btn-danger"
              >
                <trash-icon></trash-icon>
                Usuń pozycję
              </question-button>
            </td>
          </tr>
          </tbody>
        </table>
        <button class="btn btn-default" type="button" @click.prevent="addPosition(priceList.forSellers)">Dodaj pozycję</button>
      </form-group>
    </fieldset>

    <fieldset>
      <legend>Dla kupujących</legend>
      <form-group label="Pozycje cennika">
        <table class="table table-bordered">
          <thead>
          <tr>
            <td>Rodzaj pojazdu</td>
            <td>Cena</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in priceList.forBuyers">
            <td>
              <text-input v-model="item.type"></text-input>
            </td>
            <td>
              <text-input v-model="item.price"></text-input>
            </td>
            <td>
              <question-button
                question="Czy na pewno usunąć pozycję?"
                @click="removePosition(priceList.forBuyers, item)"
                class="btn btn-danger"
              >
                <trash-icon></trash-icon>
                Usuń pozycję
              </question-button>
            </td>
          </tr>
          </tbody>
        </table>
        <button class="btn btn-default" type="button" @click.prevent="addPosition(priceList.forBuyers)">Dodaj pozycję</button>
      </form-group>
    </fieldset>
    
    <submit-button :submitting="submitting"></submit-button>
  </form>
</div>
</template>
<script>
import FormGroup from './FormGroup.vue'
import TextInput from './TextInput.vue'
import SubmitButton from './SubmitButton.vue'
import DatePicker from './DatePicker.vue'
import Api from './../api'
import flash from './../Flash'
import moment from 'moment'
import TrashIcon from './TrashIcon.vue'
import QuestionButton from './QuestionButton.vue'

export default {
  components: {
    FormGroup,
    DatePicker,
    TextInput,
    SubmitButton,
    TrashIcon,
    QuestionButton,
    Api
  },
  data () {
    return {
      submitting: false,
      priceList: {
        forSellers: [],
        forBuyers: []
      },
      errors: []
    }
  },
  methods: {
    addPosition (list) {
      list.push({
        type: '',
        price: ''
      })
    },
    removePosition (list, item) {
      list.splice(list.indexOf(item), 1)
    },
    submit () {
      this.errors = []
      this.submitting = true
      Api.priceList.update(1, this.priceList).then(this.updateSuccess, this.updateError).then(() => { this.submitting = false })
    },
    updateSuccess ({body}) {
      body.date = moment(body.date).format('YYYY-MM-DD')
      this.priceList = body
      flash.success('Zapisano zmiany poprawnie')
      this.$router.push({
        name: 'PriceList'
      })
    },
    updateError ({body}) {
      const violations = body.violations
      violations.forEach(violation => {
        this.errors[violation.propertyPath] = violation.message
      })
    },
    fetchData () {
      Api.priceList.get(1).then(this.fetchSuccess)
    },
    onFetchProductsError () {
      window.alert('Wystąpił nieoczekiwany błąd podczas pobierania produktów - skontaktuj się z administratorem')
    },
    fetchSuccess ({body}) {
      body.date = moment(body.date).format('YYYY-MM-DD')
      this.priceList = body
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// PriceList.vue?62dd188c